<template>
    <div class="invalid">
        <img 
            v-lazy="newEmpty"
         alt="失效" />
         <p>{{$t("message.goods.shopsloseNew")}}</p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            emptyIcon: 'https://fr-static.shopshops.top/20200924/empty@2x.2cf24ea5f0d667cc.png',
            newEmpty: 'https://fr-static.shopshops.top/20210707/no-good.914205d47a342a34.png'
        }
    },
}
</script>
<style lang="less" scoped>
    img {
        display: block;
    }
    .invalid {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
        img {
            display: block;
            width: 132px;
            margin-bottom:23px;
        }
        p {
            font-size: 13px;
            line-height: 18px;
            color: #A4A4A4;
        }
    }
</style>
